import dayjs from 'dayjs';

const sortByDateKey = (key, order = "DESC") => {
  return (a, b) => {
    const orderVal = order === "ASC" ? 1 : -1;
    if (!a[key] && !b[key]) {
      return 0;
    }
    if (!a[key]) {
      return orderVal;
    }
    if (!b[key]) {
      return -orderVal;
    }
    return dayjs(a[key]).isBefore(b[key]) ? orderVal * -1 : orderVal;
  };
};
const sortByStringKey = (key, order = "ASC") => {
  return (a, b) => {
    const orderVal = order === "ASC" ? 1 : -1;
    if (!a[key] && !b[key]) {
      return 0;
    }
    if (!a[key]) {
      return orderVal;
    }
    if (!b[key]) {
      return -orderVal;
    }
    return a[key].localeCompare(b[key]) * orderVal;
  };
};

export { sortByDateKey, sortByStringKey };
//# sourceMappingURL=index.js.map
